export default "/images/sort-down.svg?a18c2fcd3209b814b450a0f30bbef057";